import { createAsyncThunk } from "@reduxjs/toolkit"
import { openMessage } from "../slice/messageSlice";
import { API_ANALYTIC } from "../../constants";

export const getImageAlert = createAsyncThunk(
    'image/jump',
    async (param, thunkAPI) => {
      const image = param.fileName.split('.')[0]
      const respone = await fetch(`${API_ANALYTIC}/api/file/image/${image}`, {
        method: 'get',
        headers: new Headers({
          Authorization: 'Bearer ' + param.token,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
        }),
    })
    // const responeResult = await respone.blob();
    //   return responeResult;
    if (respone.status === 200) {
      const responeResult = await respone.blob();
      return responeResult;
    } else if (respone.status === 422) {
      thunkAPI.dispatch(
        openMessage({
          message: 'Maaf File Tidak Tersedia',
          type: 'failed',
          open: true,
        }),
        )
        return ''
      }    
    },
  )
  